export const getNotificationDate = (notification) => {
  const value = notification?.createdAt || notification?.fecha;

  try {
    const date = value?.toDate ? value.toDate() : new Date(value);
    return Number.isNaN(date.getTime()) ? null : date;
  } catch {
    return null;
  }
};

const parseLocalDate = (value, endOfDay = false) => {
  if (!value) return null;

  const [year, month, day] = value.split('-').map(Number);
  if (!year || !month || !day) return null;

  return endOfDay
    ? new Date(year, month - 1, day, 23, 59, 59, 999)
    : new Date(year, month - 1, day);
};

export const isNotificationInDateRange = (notification, fromValue, toValue) => {
  const date = getNotificationDate(notification);
  const from = parseLocalDate(fromValue);
  const to = parseLocalDate(toValue, true);

  if (!date) return !from && !to;
  if (from && date < from) return false;
  if (to && date > to) return false;

  return true;
};
